export const SIDEBAR_CONFIG = {
  expandedWidth: 320,
  collapsedWidth: 80,
  toggleButtonSize: 32,
  toggleButtonPadding: 3,
  animationDuration: 300,
  breakpoint: 'md' as const,
} as const;

export type SidebarConfigType = typeof SIDEBAR_CONFIG;